import type SchedulingAssistantState from '../store/schema/SchedulingAssistantState';

export function createInitialSchedulingAssistantState(): SchedulingAssistantState {
    return {
        calendarEventData: createInitialCalendarEventData(),
        viewState: createInitialViewState(),
    };
}

export function createInitialCalendarEventData() {
    return {
        Start: null,
        End: null,
        IsAllDayEvent: false,
        RequiredAttendees: null,
        OptionalAttendees: null,
        Resources: null,
        Organizer: null,
        IsOrganizer: false,
        IsProposeNewTime: false,
        Recurrence: null,
        ParentFolderId: null,
    };
}

export function createInitialViewState() {
    return {
        gridRangeStart: null,
        gridLeft: 0,
        gridRight: 0,
        countOfDays: null,
        isExpanded: null,
        canModifyAttendees: false,
        currentGroupInAddAttendeeMode: null,
        showWorkingHoursOnly: false,
        isDirty: null,
        colorScheme: null,
        peoplePickerViewState: null,
        showRoomPicker: false,
        scrollLeft: 0,
        scrollTop: 0,
        scrollLeftMax: 0,
        leftNavWidth: 0,
        initialEnd: null,
        initialStart: null,
        initialIsAllDayEvent: false,
        originalEventEnd: null,
        originalEventStart: null,
        originalEventIsAllDayEvent: false,
        showTimeZones: false,
        IsAcceptProposeNewTime: false,
        shouldAdjustStartTimeEndTime: false,
        isAllDayEventExplicitlySet: false,
    };
}
